import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const TiktokStroke = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        d="M15.977 5.716A4.116 4.116 0 0 1 14.959 3h-.795m1.813 2.716A4.135 4.135 0 0 0 19.1 7.144v2.978a7.081 7.081 0 0 1-4.14-1.332v6.056a5.488 5.488 0 0 1-5.48 5.484 5.47 5.47 0 0 1-4.009-1.75 5.478 5.478 0 0 1 3.876-9.21m6.63-3.654-.047-.03M7.453 16.301a2.477 2.477 0 0 1-.474-1.46 2.504 2.504 0 0 1 2.5-2.503c.258 0 .507.044.74.117V9.414a5.564 5.564 0 0 0-.74-.053c-.043 0-.4.024-.444.024M14.16 3H11.98l-.004 11.938a2.504 2.504 0 0 1-2.496 2.41 2.511 2.511 0 0 1-2.03-1.042"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        fill={"none"}
      />
    </Icon>
  );
};

export default TiktokStroke;
